<template>
  <div>
    <el-tabs v-model="branchFlag" >
      <el-tab-pane label="总/分行管理" name="bankBranch"></el-tab-pane>
      <el-tab-pane label="支行管理" name="subbranch" :lazy="true">
        <BranchManage></BranchManage>
      </el-tab-pane>
    </el-tabs>
    <!-- <BranchManage v-show="branchFlag === 'subbranch'"></BranchManage> -->
    <module-card title="筛选" v-show="branchFlag === 'bankBranch'">
      <el-form :model="searchForm" :inline="true" label-position="left">
        <el-form-item label="添加时间">
          <date-range-picker :value="addTime" @getChange="value => addTime = value"/>
        </el-form-item>
        <el-form-item label="银行编号">
          <el-input v-model.trim="searchForm.newCode" placeholder="请输入银行编号" :clearable="true"/>
        </el-form-item>
        <el-form-item label="银行名称">
          <el-autocomplete
          v-model="searchForm.bankName"
          :fetch-suggestions="querySearch"
          placeholder="请输入银行名称"
          :trigger-on-focus="false"
          value-key="name"
          clearable
          style="width: 202px">
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="银行类型">
          <el-select v-model="searchForm.bankType">
            <el-option v-for="item in [{value: '', label: '全部类型'}, ...bankTypeList]" :key="item.value" :value="item.value" :label="item.label"/>
          </el-select>
        </el-form-item>
        <el-button type="primary" :loading="searchLoading" @click="search">查询</el-button>
        <el-button type="default" :loading="exportLoading" @click="handleExport">导出</el-button>
      </el-form>
    </module-card>
    <module-card title="银行管理" v-show="branchFlag === 'bankBranch'">
      <auth-button opt="add_bank" icon="el-icon-plus" label="新增银行" class="editBtn" @click.native="toAddBank">新增银行
      </auth-button>
      <batch-import
        class="batchImport"
        button-text="批量新增"
        submit-name="addBatchBank"
        templateName="批量新增银行模板"
        dialog-title="批量新增银行"
        @submit="importSubmit"
        :tableList="[
          { label: '银行编号', prop: 'newCode' },
          { label: '银行名称', prop: 'bankName' },
          { label: '失败原因', prop: 'errorMsg' }
        ]"/>
      <el-table class="table" border :data="list" v-loading="tableLoading">
        <el-table-column
          label="创建时间"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="银行类型"
          prop="bankType"
          :formatter="formatBankType">
        </el-table-column>
        <el-table-column
          label="银行名称"
          prop="name">
        </el-table-column>
        <el-table-column
          label="银行卡BIn"
          prop="bin">
        </el-table-column>
        <el-table-column
          label="银行编号"
          prop="newCode">
        </el-table-column>
        <!-- <el-table-column
          label="更新时间"
          prop="updateTime">
        </el-table-column>
        <el-table-column
          label="最近操作人"
          prop="updateUser">
          <template slot-scope="scope">
            {{ scope.row.updateUser ? scope.row.updateUser : "-"}}
          </template>
        </el-table-column>
        <el-table-column
          label="客户经理">
          <template slot-scope="scope">
            <auth-button auth-type="span" opt="edit_bank" label="查看详情" class="editBtn"
                         @click.native="checkDetail(scope.row, 'ManagerDetail')"/>
          </template>
        </el-table-column> -->
        <el-table-column label="分行状态" prop="status">
          <template slot-scope="scope">
            {{scope.row.status === 1 ? '启用' : '关闭'}}
          </template>
        </el-table-column>
        <el-table-column
          label="关联银行">
          <template slot-scope="scope">
            <auth-button auth-type="span" opt="edit_bank" label="查看详情" class="editBtn"
                         @click.native="checkDetail(scope.row, 'BankDetail')"/>
          </template>
        </el-table-column>
        <el-table-column
          width="240"
          label="操作">
          <template slot-scope="scope">
            <div class="flex-space-around">
              <auth-button auth-type="span" opt="edit_bank" label="修改" class="editBtn"
                           @click.native="changeBankInfo(scope.row)"/>
              <!-- <auth-button auth-type="span" opt="delete_bank" label="删除" class="editBtn"
                           @click.native="deleteBank(scope.row)"/> -->
              <auth-button auth-type="span" opt="delete_bank" :label="scope.row.status===1 ? '关闭' : '启用'" class="editBtn" @click.native="updateStatus(scope.row)"></auth-button>
              <auth-button auth-type="span" opt="edit_bank" label="操作记录" class="editBtn"
                           @click.native="getOperationRecords(scope.row)"
              ></auth-button>
              <auth-button auth-type="span" opt="edit_bank" label="关联银行" class="editBtn"
                           @click.native="checkDetail(scope.row, 'Relate')"/>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <pagination :count="total" :page-no="pageNo" :size="pageSize"
                  @changePage="value => { this.pageNo = value; getList() }"/>
    </module-card>
    <dialog-info
      :visible.sync="showBankDialog"
      :title="isAdd ? '新增银行' : '编辑银行'"
      @confirm="submitBank"
      @close="clearBankInfo"
      :comfirmLoading="bankEditLoading"
      size="large"
      footerAlign="center">
      <el-form ref="bankForm" :model="bankForm" :rules="ruleData" label-width="100px" label-position="left">
        <el-form-item prop="bankType" label="银行类型">
          <el-select v-model="bankForm.bankType" placeholder="请选择银行类型">
            <el-option v-for="item in bankTypeList" :key="item.value" :value="item.value"
                       :label="item.label"/>
          </el-select>
        </el-form-item>
        <el-form-item prop="name" label="银行名称">
          <el-input v-model="bankForm.name" placeholder="请输入银行名称" class="form-input"/>
        </el-form-item>
        <el-form-item prop="bin" label="银行卡BIN">
          <el-input v-model="bankForm.bin" placeholder="请输入银行卡BIN" class="form-input"/>
        </el-form-item>
        <!-- <el-form-item prop="newCode" label="银行编号">
          <el-input v-model="bankForm.newCode" placeholder="请输入银行编号" class="form-input"></el-input>
        </el-form-item> -->
        <bank-branch
          v-show="parseInt(bankForm.bankType) === 3"
          label-width="100px"
          ref="bankBranchForm"
          :value="bankBranch"
          v-model="bankBranch"
          :readOnly="false"
          @getValue="getBankBranch"
          @error="getBranchError"/>
        <!-- 支行类型选择支行 分支网点 -->
        <!-- <el-form-item prop="address" label="所在地区" v-show="bankForm.bankType === 3">
        </el-form-item> -->
        <!-- <el-form-item prop="addressInfo" label="详细地址">
          <el-input v-model="bankForm.address.address" placeholder="详细地址需超过5个字，详细到门牌号" class="form-input"></el-input>
        </el-form-item> -->
<!--        <el-form-item prop="subAccount" label="客户经理">-->
<!--          <el-form :ref="'form' + index" :model="item" v-for="(item, index) in bankManagerList" :key="index"-->
<!--                   style="display:flex;margin-bottom: 24px;">-->
<!--            <el-row type="flex" align="middle">-->
<!--              <el-form-item prop="name" class="form-flex-item" :rules="[{-->
<!--                  required: bankManagerList.length !== 1 ? item.email || item.phone || item.isDefault : item.email || item.phone,-->
<!--                  message: '请输入银行客户经理姓名',-->
<!--                  trigger: 'change'-->
<!--                  }]">-->
<!--                <el-input v-model="item.name" placeholder="请输入银行客户经理姓名" class="inner-input" clearable=""-->
<!--                          @input="validateForm(index)"/>-->
<!--              </el-form-item>-->
<!--              <el-form-item prop="phone" class="form-flex-item" :rules="[{-->
<!--                  required: bankManagerList.length !== 1 ? item.name || item.email || item.isDefault : item.name || item.email,-->
<!--                  message: '请输入银行客户经理手机号码',-->
<!--                  trigger: 'change'-->
<!--                  }, {-->
<!--                    pattern:/^\d{11,11}$/,-->
<!--                    message:'请输入正确手机格式'-->
<!--                  }]">-->
<!--                <el-input v-model="item.phone" placeholder="请输入银行客户经理手机号码" class="inner-input" clearable=""-->
<!--                          @input="validateForm(index)"/>-->
<!--              </el-form-item>-->
<!--              <el-form-item prop="email" class="form-flex-item" :rules="[{-->
<!--                  required: bankManagerList.length !== 1 ? item.name || item.phone || item.isDefault : item.name || item.phone,-->
<!--                  message: '请输入银行客户经理邮箱',-->
<!--                  trigger: 'change'-->
<!--                  }, {-->
<!--                    pattern:/^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/,-->
<!--                    message:'请输入正确邮箱格式'-->
<!--                  }]">-->
<!--                <el-input v-model="item.email" placeholder="请输入银行客户经理邮箱" class="inner-input" clearable=""-->
<!--                          @input="validateForm(index)"/>-->
<!--              </el-form-item>-->
<!--              <el-checkbox v-model="item.isDefault" @change="setDefault(index)">默认</el-checkbox>-->
<!--              <div class="icon" @click="removeManager(index)" v-show="!item.isDefault">-</div>-->
<!--              <div class="icon" @click="addManager(index)">+</div>-->
<!--            </el-row>-->
<!--          </el-form>-->
<!--        </el-form-item>-->
        <el-form-item prop="organNumber" label="管理机构编号">
          <el-input v-model="bankForm.organNumber" placeholder="请输入银行系统中的机构编号" class="form-input"/>
        </el-form-item>
      </el-form>
    </dialog-info>
    <dialog-info
      :visible.sync="showBankDetailDialog"
      title="查看详情"
      :showCancelBtn="false"
      :showConfirmBtn="false"
      size="large"
      footerAlign="center"
    >
      <el-form :model="relationBankForm" :inline="true" label-position="left">
        <el-form-item label="银行编号">
          <el-input v-model="relationBankForm.relationBankCode" placeholder="请输入银行编号" :clearable="true"/>
        </el-form-item>
        <el-form-item label="银行名称">
          <el-input v-model="relationBankForm.relationBankName" placeholder="请输入银行名称" :clearable="true"/>
        </el-form-item>
        <el-button type="primary" :loading="searchBankLoading" @click="getBankDetailList">查询</el-button>
      </el-form>
      <el-table class="table" border :data="bankDetailList" v-loading="bankDetailLoading">
        <!-- <el-table-column
          label="更新时间"
          width="170"
          prop="updateTime">
        </el-table-column> -->
        <el-table-column
          label="银行名称"
          prop="name">
        </el-table-column>
        <el-table-column
          label="银行编号"
          prop="code">
        </el-table-column>
        <el-table-column
          label="银行类型"
          prop="bankType"
          :formatter="formatBankType"
         ></el-table-column>
        <!-- <el-table-column
          label="最近操作人"
          prop="operator">
        </el-table-column> -->
        <el-table-column
          label="关联状态"
          width="90"
          prop="status">
          <template slot-scope="scope">
            <span>{{parseInt(scope.row.status) === 1 ? '开启' : '关闭'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          prop="action"
          width="120">
          <template slot-scope="scope">
            <auth-button auth-type="span" v-if="scope.row.bankType !== 3" opt="edit_bank" :label="parseInt(scope.row.status) === 1 ? '取消关联' : '重新关联'"
                         class="editBtn" @click.native="updateRelateStatus(scope.row)"/>
          </template>
        </el-table-column>
      </el-table>
      <pagination :count="detailPagination.total" :page-no="detailPagination.pageNo" :size="detailPagination.pageSize"
                  @changePage="value => { this.detailPagination.pageNo = value; getBankDetailList() }"/>
    </dialog-info>
    <dialog-info
      :visible.sync="showManagerDetailDialog"
      title="客户经理详情"
      size="large"
      footerAlign="center"
      @confirm="submitChangeDefault"
      @close="showManagerDetailDialog = false"
    >
      <el-table class="table" border :data="managerDetailList" v-loading="managerDetailLoading">
        <el-table-column
          label="添加时间"
          width="170"
          prop="createTime">
        </el-table-column>
        <el-table-column
          label="客户经理工号"
          prop="managerNo">
        </el-table-column>
        <el-table-column
          label="客户经理姓名"
          prop="name">
        </el-table-column>
        <el-table-column
          label="客户经理手机号"
          prop="phone">
        </el-table-column>
        <el-table-column
          label="操作"
          prop="action"
          width="120">
          <template slot-scope="scope">
            <el-radio v-model="scope.row.status" @change="changeDefaultManager(scope.$index)" label="1">默认</el-radio>
          </template>
        </el-table-column>
      </el-table>
<!--      <pagination :count="detailPagination.total" :page-no="detailPagination.pageNo" :size="detailPagination.pageSize"-->
<!--                  @changePage="value => { this.detailPagination.pageNo = value; getBankDetailList() }"/>-->
    </dialog-info>
    <dialog-info
      :visible.sync="showRelateDialog"
      title="关联银行"
      :confirmLoading="relateLoading"
      @confirm="relateBank"
      @close="relateForm.relateBankCode = ''"
      size="middle"
      footerAlign="center"
    >
      <el-form ref="relateForm" :model="relateForm" :rules="ruleData" label-width="85px" label-position="left">
        <el-form-item label="关联银行" prop="relateBankCode">
          <el-input type="textarea" placeholder="请输入关联银行编号，多个银行用英文,隔开" :autosize="{ minRows: 3, maxRows: 5}"
                    v-model="relateForm.relateBankCode"/>
        </el-form-item>
      </el-form>
    </dialog-info>
    <dialog-info
      :visible.sync="showOperateLogDialog"
      title="操作记录"
      size="middle"
      :showCancelBtn="false"
      footerAlign="center"
      confirmText="关闭"
      @confirm="showOperateLogDialog=false"
    >
    <el-table border :data="operateRecordsPageData" v-loading="recordsLoading">
      <el-table-column label="更新时间" prop="createTime"></el-table-column>
      <el-table-column label="操作人" prop="operatorId"></el-table-column>
      <el-table-column label="操作内容" prop="operationContent"></el-table-column>
    </el-table>
    <pagination :count="recordsPagination.total" :page-no="recordsPagination.pageNo" :size="recordsPagination.pageSize"
                  @changePage="value => { this.recordsPagination.pageNo = value; setRecordsDataByPage() }"/>
    </dialog-info>
  </div>
</template>
<script>
import dialogInfo from '@/components/layout/dialogInfo'
import pagination from '@/components/pagination'
import bankBranch from '@/components/bankBranch'
import dateRangePicker from '@/components/dateRangePicker'
import batchImport from '@/components/upload/batchImport'
import { downJumpConfirm } from '@/assets/js/utils'
import BranchManage from './components/branchManage'
export default {
  name: 'bankManage',
  components: {
    dialogInfo,
    pagination,
    bankBranch,
    dateRangePicker,
    batchImport,
    BranchManage
  },
  data () {
    return {
      branchFlag: 'bankBranch',
      showOperateLogDialog: false,
      operateRecordsData: [],
      list: [],
      total: 0,
      pageNo: 1,
      pageSize: 10,
      tableLoading: false,
      bankEditLoading: false,
      showBankDialog: false,
      isAdd: true,
      bankForm: {
        name: '',
        id: -1,
        newCode: '',
        bin: '',
        address: {
          provinceName: '',
          provinceNo: '',
          cityName: '',
          cityNo: '',
          // areaName: '',
          // areaNo: '',
          address: '',
          bankNo: '',
          bankName: ''
        },
        unionpayCode: '',
        bankType: '',
        organNumber: ''
      },
      ruleData: {
        bankType: [{
          required: true,
          message: '请选择银行类型',
          trigger: 'blur'
        }],
        name: [{
          required: true,
          message: '请输入银行名称',
          trigger: 'blur'
        }],
        bin: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入银行卡BIN'))
            } else {
              if (!/^([0-9]+,)*[0-9]+$/.test(value)) {
                callback(new Error('请输入正确格式的银行卡BIN'))
              } else {
                const arrayBin = value.split(',')
                const setBin = new Set(arrayBin)
                if (arrayBin.length !== setBin.size) {
                  callback(new Error('卡BIN输入重复'))
                } else {
                  callback()
                }
              }
            }
          },
          required: true,
          trigger: 'blur'
        }],
        relateBankCode: [{
          validator: (rule, value, callback) => {
            if (!value) {
              callback(new Error('请输入关联银行编号'))
            } else {
              if (!/^(\w+,)*\w+$/.test(value)) {
                callback(new Error('请输入正确的关联银行编号'))
              } else {
                const arrayCode = value.split(',')
                const setCode = new Set(arrayCode)
                if (arrayCode.length !== setCode.size) {
                  callback(new Error('银行编号输入重复'))
                } else {
                  callback()
                }
              }
            }
          },
          required: true,
          trigger: 'blur'
        }]
      },
      // bankManagerList: [
      //   {
      //     name: '',
      //     phone: '',
      //     email: '',
      //     isDefault: true
      //   }
      // ],
      managerDetailList: [],
      defaultIndex: 0,
      bankTypeList: [
        { value: '1', label: '总行' },
        { value: '2', label: '分行' }
        // { value: '3', label: '支行' }
      ],
      bankTypeListHashMap: {
        1: '总行',
        2: '分行',
        3: '支行'
      },
      showBankDetailDialog: false,
      showManagerDetailDialog: false,
      bankDetailLoading: false,
      managerDetailLoading: false,
      currentBankCode: '',
      showRelateDialog: false,
      relateLoading: false,
      relateForm: {
        relateBankCode: ''
      },
      bankDetailList: [],
      detailPagination: {
        total: 0,
        pageNo: 1,
        pageSize: 10
      },
      lumhBankCardId: '', // 通过校验的银行卡号
      searchForm: {
        newCode: '',
        bankName: '',
        addTimeStart: '',
        addTimeEnd: '',
        bankType: ''
      },
      relationBankForm: {
        relationBankCode: '',
        relationBankName: ''
      },
      searchLoading: false,
      exportLoading: false,
      searchBankLoading: false,
      addTime: [],
      recordsLoading: false,
      operateRecordsPageData: [],
      recordsPagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    bankBranch () {
      return {
        bankNameCode: this.bankForm.address.bankNo, // 银行类型编码
        bankCityCode: this.bankForm.address.cityNo, // 银行网点市编码
        bankAreaCode: this.bankForm.address.provinceNo, // 银行网点省编码
        bankBranchCode: this.bankForm.unionpayCode, // 分行id
        bankName: this.bankForm.address.bankName, // 银行类型编码
        bankCity: this.bankForm.address.cityName, // 银行网点市编码
        bankArea: this.bankForm.address.provinceName, // 银行网点省编码
        bankBranch: this.bankForm.bankBranch // 分行id
      }
    }
  },
  methods: {
    async init () {
      this.getList()
    },
    formatBankType (row) {
      const { bankType } = row
      return this.bankTypeListHashMap[bankType] || ''
    },
    getList () {
      this.tableLoading = true
      this.searchLoading = true
      this.searchForm.addTimeStart = this.addTime[0] || ''
      this.searchForm.addTimeEnd = this.addTime[1] || ''
      const params = Object.assign({}, this.searchForm, {
        pageSize: this.pageSize,
        pageNo: this.pageNo
      })
      this.$axios.post(this.$api.bankPageList, params).then(res => {
        if (res.respCode === '0') {
          this.list = res.data.list
          this.total = res.data.count
        }
        this.tableLoading = false
        this.searchLoading = false
      })
    },
    toAddBank () {
      this.bankForm.name = ''
      this.bankForm.newCode = ''
      this.showBankDialog = true
      this.isAdd = true
    },
    changeBankInfo (row) {
      for (const key in row) {
        row[key] && (this.bankForm[key] = row[key])
      }
      // this.$axios.post(this.$api.queryManager, {
      //   newCode: row.newCode
      // }).then(res => {
      //   if (res.respCode === '0') {
      //     if (res.data.list.length > 0) {
      //       this.bankManagerList = res.data.list.map((item, index) => {
      //         item.isDefault = item.status === '1'
      //         if (item.isDefault) {
      //           this.defaultIndex = index
      //         }
      //         return item
      //       })
      //     }
      //   }
      // })
      if (!row.bankAddress) {
        this.bankForm.address = {
          provinceName: '',
          provinceNo: '',
          cityName: '',
          cityNo: '',
          areaName: '',
          bankNo: '',
          bankName: ''
        }
      } else {
        this.bankForm.address = {
          provinceName: row.bankAddress.provinceName || '',
          provinceNo: row.bankAddress.provinceNo || '',
          cityName: row.bankAddress.cityName || '',
          cityNo: row.bankAddress.cityNo || '',
          areaName: row.bankAddress.areaName || '',
          bankNo: row.bankAddress.bankNo || '',
          bankName: row.bankAddress.addrebankNamess || ''
        }
      }
      this.$nextTick(() => {
        this.showBankDialog = true
        this.isAdd = false
      })
    },
    handleExport () {
      this.exportLoading = true
      this.$axios.post(this.$api.exportBank, this.searchForm).then((res) => {
        this.exportLoading = false
        if (res.respCode === '0') {
          downJumpConfirm.call(this)
        }
      })
    },
    submitBank () {
      let bankValid = true
      if (parseInt(this.bankForm.bankType) === 3) {
        this.$refs.bankBranchForm.$refs.form.validate(valid => {
          if (!valid) {
            bankValid = false
          }
        })
      }
      // this.bankManagerList.map((item, index) => {
      //   this.$refs[`form${index}`][0].validate(valid => {
      //     if (!valid) {
      //       bankValid = false
      //     }
      //   })
      // })
      this.$refs.bankForm.validate((valid) => {
        if (!valid) {
          bankValid = false
        }
      })
      if (!bankValid) {
        this.$message({
          type: 'warning',
          message: '请完善信息后提交！'
        })
      } else {
        let api
        let message
        this.bankEditLoading = true
        if (this.isAdd) {
          api = 'addBank'
          message = '新增成功！'
        } else {
          api = 'editBank'
          message = '编辑成功'
        }
        // this.bankForm.bankManagerList = this.bankManagerList.map(item => {
        //   return {
        //     name: item.name,
        //     phone: item.phone,
        //     email: item.email,
        //     status: item.isDefault ? '1' : '0'
        //   }
        // }).filter(item => item.name && item.phone && item.email)
        this.$axios.post(this.$api[api], this.bankForm).then(res => {
          if (res.respCode === '0') {
            this.bankEditLoading = false
            this.showBankDialog = false
            this.$message({
              type: 'success',
              message: message
            })
            this.getList()
          }
        })
      }
    },
    changeDefaultManager (index) {
      this.managerDetailList = this.managerDetailList.map((item, listIndex) => {
        if (listIndex === index) {
          item.status = '1'
        } else {
          item.status = '0'
        }
        return item
      })
      // if (index === this.defaultIndex) {
      //   this.bankManagerList[index].isDefault = true
      //   return
      // }
      // this.bankManagerList[this.defaultIndex].isDefault = false
      // this.defaultIndex = index
      // this.bankManagerList[index].isDefault = true
    },
    submitChangeDefault () {
      // console.log(this.managerDetailList)
      let id = ''
      let newCode = ''
      for (let i = 0; i < this.managerDetailList.length; i++) {
        const item = this.managerDetailList[i]
        if (item.status === '1') {
          id = item.id
          newCode = item.bankCode
          break
        }
      }
      const params = {
        id,
        newCode
      }
      this.$axios.post(this.$api.updateManagerStatus, params).then(res => {
        if (res.respCode === '0') {
          this.showManagerDetailDialog = false
        }
      })
    },
    // addManager () {
    //   this.bankManagerList.push({
    //     name: '',
    //     phone: '',
    //     email: '',
    //     isDefault: false
    //   })
    // },
    // removeManager (index) {
    //   this.bankManagerList.splice(index, 1)
    // },
    // validateForm (index) {
    //   this.$refs[`form${index}`][0].validate()
    // },
    getAddress (val) {
      const addr = this.bankForm.address.address
      this.bankForm.address = val
      this.bankForm.address.address = addr
    },
    checkDetail (row, key) {
      this.currentBankCode = row.newCode
      this[`show${key}Dialog`] = true
      if (key === 'BankDetail') {
        this.relationBankForm.relationBankCode = ''
        this.relationBankForm.relationBankName = ''
        this.getBankDetailList()
      } else if (key === 'ManagerDetail') {
        this.getManagerDetailList()
      }
    },
    getManagerDetailList () {
      this.managerDetailLoading = true
      this.$axios.post(this.$api.queryManager, {
        newCode: this.currentBankCode
      }).then(res => {
        this.managerDetailLoading = false
        if (res.respCode === '0') {
          if (res.data.length > 0) {
            this.managerDetailList = res.data.map((item, index) => {
              item.isDefault = item.status === '1'
              if (item.isDefault) {
                this.defaultIndex = index
              }
              return item
            })
          }
        }
      })
    },
    getBankDetailList () {
      this.bankDetailLoading = true
      this.$axios.post(this.$api.relateBankList, {
        relationBankCode: this.relationBankForm.relationBankCode,
        relationBankName: this.relationBankForm.relationBankName,
        newCode: this.currentBankCode,
        pageNo: this.detailPagination.pageNo,
        pageSize: this.detailPagination.pageSize
      }).then(res => {
        this.bankDetailLoading = false
        if (res.respCode === '0') {
          this.bankDetailList = res.data.list
          this.detailPagination.total = res.data.count
        }
      })
    },
    relateBank () {
      this.$refs.relateForm.validate(valid => {
        if (valid) {
          const params = {
            newCode: this.currentBankCode,
            relativeBankId: this.relateForm.relateBankCode.split(',')
          }
          this.relateLoading = true
          this.$axios.post(this.$api.relateBank, params).then(res => {
            this.relateLoading = false
            if (res.respCode === '0') {
              if (res.data.notRelativeId.length === 0) {
                this.$message({
                  type: 'success',
                  message: '关联成功',
                  showClose: true
                })
              } else {
                this.$message({
                  type: 'success',
                  message: `已关联成功${res.data.relativeCount}个，其中银行编号${res.data.notRelativeId.join(',')}不存在，请重新关联`,
                  showClose: true
                })
              }
              this.getList()
              this.showRelateDialog = false
            } else {
              this.$message({
                type: 'error',
                message: res.respMsg,
                showClose: true
              })
            }
          })
        } else {
          this.$message({
            type: 'warning',
            message: '请完善信息后提交！'
          })
        }
      })
    },
    updateRelateStatus (row) {
      const params = {
        code: row.code,
        parentCode: this.currentBankCode,
        status: parseInt(row.status) === 1 ? 0 : 1
      }
      this.$axios.post(this.$api.updateRelateBank, params).then(res => {
        if (res.respCode === '0') {
          this.$message({
            type: 'success',
            message: res.respMsg,
            showClose: true
          })
          this.getBankDetailList()
        }
      })
    },
    clearBankInfo () {
      this.showBankDialog = false
      this.bankForm = this.$options.data().bankForm
      // this.bankManagerList = [
      //   {
      //     name: '',
      //     phone: '',
      //     email: '',
      //     isDefault: true
      //   }
      // ]
      this.defaultIndex = 0
      this.$nextTick(() => {
        this.$refs.bankForm.clearValidate()
        this.$refs.bankBranchForm && this.$refs.bankBranchForm.$refs.form.clearValidate()
        this.$refs.form0[0].clearValidate()
      })
    },
    getBankBranch (val) {
      this.bankForm.address.bankNo = val.bankNameCode // 银行类型编码
      this.bankForm.address.cityNo = val.bankCityCode // 银行类型编码
      this.bankForm.address.provinceNo = val.bankAreaCode // 银行类型编码
      this.bankForm.unionpayCode = val.bankBranchCode // 分行id
      this.bankForm.address.bankName = val.bankName // 银行类型编码
      this.bankForm.address.cityName = val.bankCity // 银行类型编码
      this.bankForm.address.provinceName = val.bankArea // 银行类型编码
      this.bankForm.bankBranch = val.bankBranch // 分行id
    },
    /**
       * @description 银行分行联动银行错误回调
       * @param {Object} value 组件传的参数，银行名称是否错误
       */
    getBranchError (value) {
      this.bankTypeError = value
    },
    deleteBank (row) {
      this.$confirm('是否确认删除该银行', '温馨提示').then(res => {
        this.$axios.get(this.$api.deleteBank, {
          params: {
            newCode: row.newCode
          }
        }).then(res => {
          if (res.respCode === '0') {
            this.$message({
              type: 'success',
              showClose: 'true',
              message: '删除成功'
            })
            this.getList()
          }
        })
      })
    },
    search () {
      // this.pagination
      this.pageNo = 1
      this.getList()
    },
    importSubmit (result) {
      if (result) {
        this.getList()
      }
    },
    querySearch (queryString, cb) {
      const result = []
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        if (queryString === '') {
          cb(result)
        } else {
          this.$axios.post(this.$api.bankFuzzySearch, {
            bankName: queryString
          }).then(res => {
            if (res.respCode === '0') {
              var result = res.data.list
              cb(result)
            } else {
              result = []
              cb(result)
            }
          })
        }
      }, 1000)
    },
    getOperationRecords (row) {
      this.showOperateLogDialog = true
      this.recordsPagination.pageNo = 1
      this.recordsPagination.pageSize = 10
      const params = { bankCode: row.newCode }
      this.recordsLoading = true
      this.$axios.post(this.$api.operationRecords, params).then(res => {
        this.recordsLoading = false
        if (res.respCode === '0') {
          this.operateRecordsData = res.data
          this.recordsPagination.total = res.data.length || 0
          this.setRecordsDataByPage()
        } else {
          this.operateRecordsData = []
          this.operateRecordsPageData = []
          this.recordsPagination.total = 0
        }
      }).catch(() => {
        this.recordsLoading = false
        this.operateRecordsData = []
        this.operateRecordsPageData = []
        this.recordsPagination.total = 0
      })
    },
    setRecordsDataByPage () {
      const begin = (this.recordsPagination.pageNo - 1) * this.recordsPagination.pageSize
      const end = this.recordsPagination.pageSize * this.recordsPagination.pageNo
      this.operateRecordsPageData = this.operateRecordsData.slice(begin, end)
    },
    updateStatus (row) {
      const content = row.status === 1 ? '确认关闭？' : '确认启用？'
      this.$confirm(content, '温馨提示', {
        type: 'warning'
      }).then(() => {
        const params = {
          newCode: row.newCode,
          status: row.status === 1 ? 0 : 1
        }
        this.$axios.post(this.$api.updateBankStatus, params).then(res => {
          if (res.respCode === '0') {
            this.$message({
              type: 'success',
              message: '操作成功'
            })
            this.getList()
          }
        })
      })
    }
  }
}
</script>
<style scoped>
  .table {
    margin-top: 20px;
  }

  .form-flex-item {
    margin-right: 5px;
  }

  .icon {
    width: 14px;
    height: 14px;
    text-align: center;
    font-size: 12px;
    line-height: 12px;
    border-radius: 50%;
    display: inline-block;
    background: #409EFF;
    color: #fff;
    margin-left: 12px;
    cursor: pointer;
    user-select: none; /* Standard syntax */
  }

  .form-input {
    width: 610px;
  }

  .inner-input {
    width: 230px;
  }
</style>
